import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@material-ui/core";
import uploadPhoto from "../../Image/upload 1.png";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import "./Modal.css";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  input: {
    display: "none",
  },
}));

function SubmitAfterModal({ setAfterSubmitModalOpen }) {
  const classes = useStyles();
  return (
    <div className="modalBackground submitAfterModal">
      <div className="modalContainer">
        <div className="titleCloseBtn">
          <button
            onClick={() => {
              setAfterSubmitModalOpen(false);
            }}
          >
            X
          </button>
        </div>
        <div className="title">
          <h1>Registration Confirmation</h1>
        </div>
        <div className="subtitle">
          <p>
            We will verify your documents and send you the login details to your
            registered email adreess within 48 hours.
          </p>
        </div>
        <div className="footer">
          <Link to={"/"}>
            {" "}
            <button>Back to Home Page</button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default SubmitAfterModal;
